export default __webpack_public_path__ + "static/media/582.d53a8bc5.jpg";